import { Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { descriviStato } from '../../lib/eventi/stati';
import type { PartecipazioneContatto } from '../../lib/eventi/tipi';
import { BadgeStato } from './BadgeStato';
import { TabellaPercorso } from './TabellaPercorso';

type Props = {
  eventi: PartecipazioneContatto[];
  nonLeggibili?: boolean;
};

/** Chi puo' aprire la pagina di un evento (le altre persone vedono solo il riassunto). */
const RUOLI_EVENTI = ['admin', 'commerciale'];

/**
 * La sezione "Eventi" nella scheda di un contatto: per ogni evento a cui
 * partecipa, a che punto e' e il percorso chiesto e assegnato. Sola lettura:
 * si cambia dalla pagina dell'evento.
 */
export function EventiDelContatto({ eventi, nonLeggibili }: Props) {
  const { profile } = useAuth();
  const puoAprire = RUOLI_EVENTI.includes(String(profile?.role ?? ''));

  if (!nonLeggibili && eventi.length === 0) return null;

  return (
    <div>
      <p className="text-xs font-medium text-neutral-500 uppercase tracking-wider mb-2">Eventi</p>
      {nonLeggibili && <p className="text-xs text-neutral-400">Non riesco a leggere gli eventi di questo contatto.</p>}
      <ul className="space-y-3">
        {eventi.map((e) => (
          <li key={e.id} className="rounded-lg border border-gray-200 p-3 space-y-2">
            <div className="flex flex-wrap items-center gap-2">
              {puoAprire ? (
                <Link to={`/eventi/${e.evento_id}?scheda=richieste`} className="text-sm font-semibold text-primary-700 hover:underline">
                  {e.evento_nome}
                </Link>
              ) : (
                <span className="text-sm font-semibold text-gray-900">{e.evento_nome}</span>
              )}
              <BadgeStato partecipante={e} />
            </div>
            <p className="text-[11px] text-neutral-500">{descriviStato(e)}</p>
            {(e.richiesta || e.assegnazione_stato !== 'nessuna') && (
              <TabellaPercorso
                programma={e.programma}
                richiesta={e.richiesta}
                assegnazione={e.assegnazione_stato === 'nessuna' ? null : e.assegnazione}
              />
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
